import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { NgProgressModule } from 'ngx-progressbar';

import { CookieConsentComponent } from '@usheru-hff/hff-common/feature-cookie-consent';
import { ModalPictureComponent } from '@usheru-hff/hff-common/feature-modal-picture';
import { HffCommonUiGoToTopModule } from '@usheru-hff/hff-common/ui-go-to-top';
import { HffCommonUiHeaderModule } from '@usheru-hff/hff-common/ui-header';
import { VideoFullscreenComponent } from '@usheru-hff/hff-common/ui-video-fullscreen';
import { addLazyBrandedRoute, addRoute } from '@usheru-hff/hff-common/util-routes';
import { UiModalDialogComponent } from '@usheru-hff/shared/ui-modal-dialog';
import { VideoFullscreenService } from '@usheru-hff/shared/ui-video';
import { ModalPictureService, SharedUtilsModule } from '@usheru-hff/shared/utils';
import { ModalService } from '@usheru-hff/shared/utils-modal';

import { AconFooterComponent } from './footer/acon-footer.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    CommonModule,
    RouterLink,
    RouterOutlet,
    HffCommonUiHeaderModule,
    VideoFullscreenComponent,
    ModalPictureComponent,
    CookieConsentComponent,
    AconFooterComponent,
    HffCommonUiGoToTopModule,
    UiModalDialogComponent,
    SharedUtilsModule,
    NgProgressModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  activatedPath: string;

  private readonly modalPictureService = inject(ModalPictureService);
  private readonly videoFullScreenService = inject(VideoFullscreenService);
  private readonly modalService = inject(ModalService);

  constructor(private router: Router) {
    const routes = this.router.config;

    addRoute(routes, [
      {
        path: 'catalogo',
        loadComponent: () =>
          import('./acontra-catalogo/acontra-catalogo.component').then(m => m.AcontraCatalogoComponent)
      }
    ]);
    addLazyBrandedRoute(routes, 'tutankhamun-the-last-exhibition', () =>
      import('./movies/tutankhamun/tutankhamun.component').then(m => m.TutankamonComponent)
    );

    addLazyBrandedRoute(routes, 'belle-2', () => import('./movies/belle/belle.component').then(m => m.BelleComponent));
    addLazyBrandedRoute(routes, 'no-somos-nada', () =>
      import('./movies/no-somos-nada/no-somos-nada.component').then(m => m.NoSomosNadaComponent)
    );
  }

  modalPictureNeeded$ = this.modalPictureService.image;
  videoFullscreenNeeded$ = this.videoFullScreenService.content$;
  modelDialogNeeded$ = this.modalService.showModal$;
}
